import { render, staticRenderFns } from "./WhatsappListSettingsModal.vue?vue&type=template&id=b8b4e336&scoped=true"
import script from "./WhatsappListSettingsModal.vue?vue&type=script&lang=js"
export * from "./WhatsappListSettingsModal.vue?vue&type=script&lang=js"
import style0 from "./WhatsappListSettingsModal.vue?vue&type=style&index=0&id=b8b4e336&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b4e336",
  null
  
)

export default component.exports